import { RootState } from '../../RootState';
import selectSessionContent from './selectSessionContent';

const selectSessionSelectedWishlist = (state: RootState): string | null => {
  const { selectedWishlist } = selectSessionContent(state);
  return selectedWishlist;
};

export default selectSessionSelectedWishlist;
